import { render, staticRenderFns } from "./sinformation.vue?vue&type=template&id=2ad63afb&scoped=true&"
import script from "./sinformation.vue?vue&type=script&lang=js&"
export * from "./sinformation.vue?vue&type=script&lang=js&"
import style0 from "./sinformation.vue?vue&type=style&index=0&id=2ad63afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad63afb",
  null
  
)

export default component.exports